export const debugBuild = false;
export function colorConsole(message: string) {
  if (debugBuild)
    console.log(`%c${message}`, ` background: #64dd17; color: black; font-size: 14px ; font-weight: bold;` + message);
}
